import React, { useState } from 'react';
import { SuccessDialog, ErrorDialog } from '../../../components';
import { MenuItem } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { departments, NOT_SELECTED } from '../../../constants/volunteers';
import {
  ASSIGN_VOLUNTEER_ENDPOINT,
  SERVER_HOST,
} from '../../../constants/endpoints';
import utils from '../../../utils';

export default function Acceptance(props) {
  const [departmentID, setDepartmentID] = useState(NOT_SELECTED);
  const [isSuccessDialog, setSuccessDialog] = useState(false);
  const [isErrorDialog, setErrorDialog] = useState(false);
  const { open, handleClose, userID } = props;

  const assignVolunteer = () => {
    // TODO: This endpoint does not work
    fetch(SERVER_HOST + ASSIGN_VOLUNTEER_ENDPOINT(userID), {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        newDepartmentID: departmentID,
      }),
    })
      .then((response) => response.json())
      .then(() => {
        handleClose();
        setSuccessDialog(true);
      })
      .catch(() => setErrorDialog(true));
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={props.handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Закрепление за Отделом</DialogTitle>
        <DialogContent>
          <DialogContentText>
            За каким Отделом Духовного Центра Вы бы хотели закрепить кандидата
            <b>{' ' + props.fullName}</b>?
          </DialogContentText>
          <TextField
            id="outlined-select-currency"
            select
            fullWidth
            label="Название Отдела"
            value={departmentID}
            onChange={(event) => setDepartmentID(event.target.value)}
            variant="outlined"
          >
            {departments.map((option) => (
              <MenuItem key={option.id} value={option.id}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary">
            Отменить
          </Button>
          <Button onClick={assignVolunteer} color="primary">
            Закрепить
          </Button>
        </DialogActions>
      </Dialog>

      <SuccessDialog
        isSuccessDialog={isSuccessDialog}
        setSuccessDialog={setSuccessDialog}
        description={`Волонтёр ${props.fullName} успешно прикреплён в
          ${' ' + utils.searchByConstant(departments, departmentID, 'label')}!`}
      />

      <ErrorDialog
        isErrorDialog={isErrorDialog}
        setErrorDialog={setErrorDialog}
      />
    </div>
  );
}
